// extracted by mini-css-extract-plugin
module.exports = {"main-component":"uploadIcon_main-component__2xa-Y"};